/**
 * Публичные данные магазина для клиентских страниц (заказ, share и т.д.).
 * Переопределяются через REACT_APP_STORE_* / REACT_APP_WHATSAPP_PHONE.
 */
const DEFAULTS = {
  name: "АвтоВАЗ.KZ",
  subtitle: "Запчасти для ВАЗ",
  address: "Петропавловск, Интернациональная 21",
};

function trimOrFallback(value, fallback) {
  const s = String(value || "").trim();
  return s || fallback;
}

export function getStoreConfig() {
  const phone =
    trimOrFallback(process.env.REACT_APP_STORE_PHONE, "") ||
    trimOrFallback(process.env.REACT_APP_WHATSAPP_PHONE, "");
  const phoneDigits = phone.replace(/\D/g, "");

  return {
    name: trimOrFallback(process.env.REACT_APP_STORE_NAME, DEFAULTS.name),
    subtitle: trimOrFallback(process.env.REACT_APP_STORE_SUBTITLE, DEFAULTS.subtitle),
    address: trimOrFallback(process.env.REACT_APP_STORE_ADDRESS, DEFAULTS.address),
    phone,
    phoneDigits,
    mapUrl: trimOrFallback(process.env.REACT_APP_STORE_2GIS_URL, ""),
    logoUrl: trimOrFallback(process.env.REACT_APP_STORE_LOGO_URL, ""),
  };
}

export function buildStoreWhatsAppUrl(message = "Здравствуйте!") {
  const { phoneDigits } = getStoreConfig();
  if (!phoneDigits) return null;
  return `https://wa.me/${phoneDigits}?text=${encodeURIComponent(message)}`;
}

export function formatStorePhone(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("7")) {
    return `+7 ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9)}`;
  }
  return phone || "";
}
